<template>
  <v-row v-if="!loading">
    <InterestButton
      v-for="index in 3"
      :key="index"
      :interest="index"
      :active="interest >= index"
      :class="{ 'd-print-none': interest < index }"
      :disabled="disabled"
      @click="setInterest(index)"
    ></InterestButton>
  </v-row>
  <v-row v-else>
    <DataLoader :custom-loading-trigger="loading"></DataLoader>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import InterestButton from '@/components/activities/InterestButton.vue'
import DataLoader from '@/components/common/DataLoader.vue'

export default {
  name: 'Interest',
  components: { DataLoader, InterestButton },
  props: {
    selection: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      interest: 1
    }
  },
  watch: {
    selection: {
      immediate: true,
      handler(selection) {
        this.interest = selection.interest
      }
    }
  },
  methods: {
    ...mapMutations('page', ['setDataLoadingEnabled']),
    ...mapActions('activities', ['updateJobApplicationActivitySelection']),
    setInterest(interest) {
      this.loading = true
      this.setDataLoadingEnabled(false)
      this.interest = interest
      this.updateJobApplicationActivitySelection({
        id: this.selection.id,
        data: {
          interest,
          job_application_id: this.selection.job_application_id
        }
      }).finally(() => {
        this.setDataLoadingEnabled(true)
        this.loading = false
      })
    }
  }
}
</script>

<style scoped></style>
